import { Link } from 'react-router-dom';
import { findContributorTask, useKitCopy } from '@/features/contribution-kit';
import { Icon } from '@/lib/icons';
import { cn } from '@/lib/utils';

const copy = {
  fr: { label: "Façon d'écrire" },
  en: { label: 'Way of writing' },
} as const;

/**
 * The two writing tasks side by side: "Transcrire" (hear a recording, write
 * it) and "Traduire" (read a French phrase, write it in the local language).
 * Plain links to each route, labels from contributorTasks().
 */
export function WriteModeSwitch({ active, className }: { active: 'transcribe' | 'translate'; className?: string }) {
  const { lang } = useKitCopy();
  const modes = (['transcribe', 'translate'] as const).map((key) => findContributorTask(lang, key));

  return (
    <nav aria-label={copy[lang].label} className={cn('grid grid-cols-2 gap-1 rounded-lg border border-border/60 bg-surface p-1 sm:inline-grid', className)}>
      {modes.map((mode) => {
        const isActive = mode.key === active;
        return (
          <Link
            key={mode.key}
            to={mode.href}
            aria-current={isActive ? 'page' : undefined}
            className={cn(
              'inline-flex h-11 min-w-0 items-center justify-center gap-2 rounded-md px-4 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              isActive ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-surface-2 hover:text-foreground',
            )}
          >
            <Icon name={mode.icon} className="size-4 shrink-0" />
            <span className="truncate">{mode.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
